"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Select_1 = __importDefault(require("../inputs/Select"));
var FilterBarSearch_1 = __importDefault(require("./FilterBarSearch"));
var FilterBar = function (_a) {
    var label = _a.label, perPage = _a.perPage, onPerPageChange = _a.onPerPageChange, searchValue = _a.searchValue, onSearchChange = _a.onSearchChange;
    var changeHandler = function (e) {
        onSearchChange(e.currentTarget.value);
    };
    return (react_1.default.createElement("div", { className: 'filter-bar flex flex-row flex-space-between' },
        react_1.default.createElement("div", { className: 'filter-bar__section flex flex-row' },
            react_1.default.createElement("span", { className: 'filter-bar__label' }, "Show"),
            react_1.default.createElement(Select_1.default, { value: perPage, options: [
                    { value: 10, text: '10' },
                    { value: 25, text: '25' },
                    { value: 50, text: '50' },
                ], onChange: onPerPageChange }),
            react_1.default.createElement("span", { className: 'filter-bar__label' }, label)),
        react_1.default.createElement("div", { className: 'filter-bar__section' },
            react_1.default.createElement(FilterBarSearch_1.default, { value: searchValue, onChange: changeHandler }))));
};
exports.default = FilterBar;
